export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    startDate: {
        label: "Start date"
    },
    finishDate: {
        label: "Finish date"
    },
    refDivisionId: {
        label: "Division"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    startDate: {
        label: "Date de début"
    },
    finishDate: {
        label: "Date de fin"
    },
    refDivisionId: {
        label: "Service"
    }
};